import { attach, createEvent, createStore } from 'effector';
import { saveLayoutFx } from '../../entities/chart';

export const chartSymbolsOpened = createEvent();
export const closed = createEvent();

/** The dialog's own save: a period change elsewhere never closes the dialog or shows its error. */
export const saveSymbolsFx = attach({ effect: saveLayoutFx });

export const $open = createStore(false)
  .on(chartSymbolsOpened, () => true)
  .reset(closed, saveSymbolsFx.done);

export const $saveError = createStore<string | null>(null)
  .on(saveSymbolsFx.failData, (_, error) => error.message)
  .reset(chartSymbolsOpened, saveSymbolsFx);
